<ng-container *transloco="let t">
  <p-panel [showHeader]="false" styleClass="p-panel-no-header p-panel-with-controls">
    <div class="container">
      <div class="icon">
        <i class="fad fa-bomb"></i>
      </div>

      <div class="title">{{ t('core.pages.server_error.title') }}</div>

      <div class="message">{{ t('core.pages.server_error.message') }}</div>

      <div class="buttons">
        <button
          pButton
          type="button"
          icon="fad fa-arrow-left"
          label="{{ t('core.pages.server_error.go_back') }}"
          class="p-button-text mr-2"
          (click)="goBack()"
        ></button>

        <button
          pButton
          type="button"
          icon="fa-duotone fa-house"
          label="{{ t('core.pages.server_error.home') }}"
          class="p-button-text"
          (click)="goHome()"
        ></button>
      </div>
    </div>
  </p-panel>
</ng-container>
